(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["Manual-product-addon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wb-manual-addon')) {
  customElements.define('wb-manual-addon', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.toggle = this.querySelector('[data-addon-toggle]');
      this.status = this.querySelector('[data-addon-status]');
      const findVariant = () => this.querySelector('[data-addon-variant]:checked');
      const refresh = () => {
        const selected = findVariant();
        if (!selected) return;
        this.querySelector('[data-addon-price]').textContent = selected.dataset.price;
        const compare = this.querySelector('[data-addon-compare-price]');
        if (compare) { compare.textContent = selected.dataset.compare; compare.hidden = !selected.dataset.compare; }
        const badge = this.querySelector('[data-addon-discount]');
        if (badge) { const saving = Number(selected.dataset.discount); badge.textContent = 'Save ' + saving + '%'; badge.hidden = saving <= 0; }
        this.classList.toggle('is-selected', this.toggle.checked);
      };
      this.addEventListener('change', refresh, {signal});
      this.querySelector('[data-addon-card]').addEventListener('click', event => {
        if (this.dataset.clickBox !== 'true' || event.target.closest('a, input, label, button, select') || this.toggle.disabled) return;
        this.toggle.checked = !this.toggle.checked;
        refresh();
      }, {signal});
      refresh();
      const initialise = () => {
        if (!this.isConnected || this.form) return;
        const scope = this.closest('product-info') || this.closest('.shopify-section');
        this.form = document.getElementById(this.dataset.formId);
        if (!this.form && scope) {
          try { this.form = Array.from(scope.querySelectorAll(this.dataset.mainFormSelector)).find(form => form.querySelector('[name="id"]') && form.querySelector('[type="submit"]')); }
          catch { this.status.textContent = 'The add-on form setting needs updating.'; this.status.hidden = false; }
        }
        if (!this.form) return;
        const submit = async event => {
          this.form = document.getElementById(this.dataset.formId) || this.form;
          if (!this.form || !this.form.isConnected) return;
          if (!this.toggle.checked && !this.busy && !this.cartNeedsReview) return;
          if (event.type === 'submit' && event.target !== this.form) return;
          const trigger = event.type === 'click' ? event.target.closest('button[type="submit"],input[type="submit"]') : event.submitter;
          if (event.type === 'click' && (!trigger || trigger.form !== this.form)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.busy) return;
          if (this.cartNeedsReview) { window.location.assign(this.dataset.cartUrl); return; }
          const selected = findVariant();
          if (!selected || selected.disabled) return;
          if (!this.form.checkValidity()) { this.form.reportValidity(); return; }
          const data = new FormData(this.form);
          const mainId = data.get('id');
          if (!mainId) { this.status.textContent = 'Please select an available product option.'; this.status.hidden = false; return; }
          let quantity = Math.max(1, parseInt(data.get('quantity') || '1', 10) || 1);
          const bundle = scope?.querySelector('[data-name="volume-discount"][aria-checked="true"] .ast-vd-2__option__title');
          const match = bundle?.textContent.match(/Buy\s+(\d+)/i);
          if (match) quantity = Number(match[1]);
          data.set('quantity', String(quantity));
          const mainItem = {id: mainId, quantity};
          if (data.get('selling_plan')) mainItem.selling_plan = data.get('selling_plan');
          const properties = {};
          let hasFiles = false;
          for (const [key, value] of data.entries()) {
            if (!key.startsWith('properties[')) continue;
            if (value instanceof File) { if (value.size) hasFiles = true; }
            else properties[key.slice(11, -1)] = value;
          }
          if (Object.keys(properties).length) mainItem.properties = properties;
          const postItem = async (item, formData) => {
            const response = await new Promise((resolve, reject) => {
              const request = new XMLHttpRequest();
              request.open('POST', (window.Shopify?.routes?.root || '/') + 'cart/add.js?source=wb_manual_addon');
              request.timeout = 20000;
              request.setRequestHeader('Accept', 'application/json');
              if (!formData) request.setRequestHeader('Content-Type', 'application/json');
              request.onload = () => resolve({ok: request.status >= 200 && request.status < 300, text: request.responseText});
              request.onerror = () => reject(new Error('Connection interrupted. Please check your cart before trying again.'));
              request.ontimeout = () => reject(new Error('The request timed out. Please check your cart before trying again.'));
              request.send(formData || JSON.stringify(item));
            });
            const result = JSON.parse(response.text);
            if (!response.ok) throw new Error(result.description || result.message || 'This product could not be added.');
            if (String(result.variant_id || result.id) !== String(item.id)) throw new Error('Please check the products in your cart.');
            return result;
          };
          this.busy = true;
          this.status.hidden = true;
          const buttons = Array.from(this.form.querySelectorAll('[type="submit"]')).map(button => ({button, disabled: button.disabled}));
          buttons.forEach(({button}) => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
          try {
            this.cartNeedsReview = true;
            await postItem(mainItem, hasFiles ? data : null);
            this.mainAdded = true;
            await postItem({id: selected.value, quantity: 1});
            window.location.assign(this.dataset.cartUrl);
          } catch (error) {
            this.status.textContent = (this.mainAdded ? 'Your main product was added, but the optional item could not be confirmed. ' : '') + (error.message || 'Unable to add products.');
            const link = document.createElement('a');
            link.href = this.dataset.cartUrl;
            link.textContent = ' View your cart';
            this.status.append(link);
            this.status.hidden = false;
          } finally {
            this.busy = false;
            buttons.forEach(({button, disabled}) => { button.disabled = disabled; button.removeAttribute('aria-busy'); });
          }
        };
        window.addEventListener('submit', submit, {capture: true, signal});
        window.addEventListener('click', submit, {capture: true, signal});
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once: true, signal});
      else initialise();
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; this.form = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wb-product-extras"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wb-sticky-cart')) {
    customElements.define('wb-sticky-cart', class extends HTMLElement {
      connectedCallback() {
        this.main = document.getElementById(`MainProduct-${this.dataset.section}`);
        this.button = this.querySelector('[data-wb-submit]');
        this.price = this.querySelector('[data-wb-price]');
        this.update = () => {
          const form = document.getElementById(this.dataset.form);
          const submit = form?.querySelector('[type="submit"][name="add"]');
          if (!submit) { this.hidden = true; return; }
          const unavailable = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
          this.button.disabled = unavailable;
          const label = submit.querySelector('span')?.textContent.trim() || submit.textContent.trim();
          if (this.button.firstElementChild.textContent !== label) this.button.firstElementChild.textContent = label;
          const currentPrice = this.main.querySelector('.price:not(.wb-sticky-cart .price)');
          const bundlePrice = this.main.querySelector('[role="radio"][data-name="volume-discount"][aria-checked="true"] .ast-price');
          const priceValue = bundlePrice || (currentPrice?.classList.contains('price--on-sale') ? currentPrice.querySelector('.price-item--sale') : currentPrice?.querySelector('.price-item--regular'));
          if (this.price && priceValue && this.price.textContent !== priceValue.textContent.trim()) this.price.textContent = priceValue.textContent.trim();
          const rect = submit.getBoundingClientRect();
          this.hidden = this.dataset.display !== 'always' && rect.bottom >= 0;
        };
        this.add = () => {
          const form = document.getElementById(this.dataset.form);
          const submit = form?.querySelector('[type="submit"][name="add"]');
          if (submit && !submit.disabled && submit.getAttribute('aria-disabled') !== 'true') submit.click();
        };
        this.button.addEventListener('click', this.add);
        this.observer = new MutationObserver(records => {
          if (records.some(record => !this.contains(record.target))) this.update();
        });
        if (this.main) this.observer.observe(this.main, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-checked', 'class']});
        window.addEventListener('scroll', this.update, {passive: true});
        window.addEventListener('resize', this.update);
        this.update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.button?.removeEventListener('click', this.add);
        window.removeEventListener('scroll', this.update);
        window.removeEventListener('resize', this.update);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wb-product-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wb-product-reviews')) {
  customElements.define('wb-product-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.track = this.querySelector('.wb-reviews__track');
      this.slides = Array.from(this.querySelectorAll('.wb-reviews__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-review-dot]'));
      this.index = 0;
      const controls = this.querySelector('.wb-reviews__controls');
      if (!controls) return;
      controls.hidden = false;
      this.dataset.ready = 'true';
      const update = () => {
        const trackLeft = this.track.getBoundingClientRect().left;
        let closest = Infinity;
        this.slides.forEach((slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
          if (distance < closest) { closest = distance; this.index = index; }
        });
        this.dots.forEach((dot, index) => {
          if (index === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };
      const go = index => {
        this.index = (index + this.slides.length) % this.slides.length;
        const left = this.slides[this.index].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
        this.track.scrollBy({left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.querySelector('[data-review-prev]').addEventListener('click', () => go(this.index - 1), {signal});
      this.querySelector('[data-review-next]').addEventListener('click', () => go(this.index + 1), {signal});
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => go(index), {signal}));
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(update);
      }, {passive: true, signal});
      this.track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, {signal});
      this.resize = new ResizeObserver(update);
      this.resize.observe(this.track);
      update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
